import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";

// material-ui
import {
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputLabel,
    Link,
    OutlinedInput,
    Stack,
    Typography,
} from "@mui/material";

// third party
import * as Yup from "yup";
import { useFormik } from "formik";

const LoginForm = (props) => {
    const navigate = useNavigate();

    const { handleSubmit } = props;

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
            submit: null,
        },
        //validationSchema: Yup.object(),
        onSubmit: async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
                setStatus({ success: false });
                setSubmitting(false);
                // Only redirect to HOME page.
                await handleSubmit(values);
            } catch (err) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
            }
        },
    });

    return (
        <>
            <form noValidate onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <InputLabel>Username</InputLabel>
                            <OutlinedInput
                                type="text"
                                name="username"
                                value={formik.values.username}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                placeholder="Username"
                                fullWidth
                                error={Boolean(formik.touched.username && formik.errors.username)}
                            />
                            {Boolean(formik.touched.username && formik.errors.email) ? (
                                <FormHelperText error>{formik.errors.username}</FormHelperText>
                            ) : null}
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <InputLabel>Password</InputLabel>
                            <OutlinedInput
                                type="password"
                                name="password"
                                value={formik.values.password}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                placeholder="Password"
                                fullWidth
                                error={Boolean(formik.touched.password && formik.errors.password)}
                            />
                            {Boolean(formik.touched.password && formik.errors.password) ? (
                                <FormHelperText error>{formik.errors.password}</FormHelperText>
                            ) : null}
                        </Stack>
                    </Grid>

                    {/**
                    <Grid item xs={12} sx={{ mt: -1 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        // checked={false}
                                        // onChange={formik.values.checked}
                                        name="checked"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<Typography variant="h6">Keep me sign in</Typography>}
                            />
                            <Link variant="h6" component={RouterLink} to="" color="text.primary">
                                Forgot Password?
                            </Link>
                        </Stack>
                    </Grid>
                    */}

                    {formik.errors.submit && (
                        <Grid item xs={12}>
                            <FormHelperText error>{formik.errors.submit}</FormHelperText>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Divider>
                            <Typography variant="caption">Login with PSU Passport</Typography>
                        </Divider>
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            disableElevation
                            disabled={formik.isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Login
                        </Button>
                    </Grid>
                    {/**
                    <Grid item xs={12}>
                        [PSU Passport] [...]
                    </Grid>
                     */}
                </Grid>
            </form>
        </>
    );
};

export default LoginForm;
